import React, { PropTypes } from 'react'
import Toggle from 'material-ui/Toggle'
import { grey500 } from 'material-ui/styles/colors'

const styles = {
  label: {
    color: grey500,
    fontSize: '0.8em',
    marginTop: '15px',
    display: 'block'
  }
}

const FlagList = ({ label, value, flags, onChange }) => {
  const isToggled = flag => value[flag] === true
  const handleToggle = flag => () => {
    onChange(null, Object.assign({}, value, {
      [flag]: !isToggled(flag)
    }))
  }

  return (
    <div>
      <label style={styles.label}>{label}</label>
      {
        flags.map(({ name, value }) => {
          return (
            <Toggle
              key={`flag-${value}`}
              label={name}
              labelPosition='right'
              toggled={isToggled(value)}
              style={{ marginTop: '1em' }}
              onToggle={handleToggle(value)}
            />
          )
        })
      }
    </div>
  )
}

// @ts-ignore
FlagList.propTypes = {
  label: PropTypes.string.isRequired,
  flags: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    })
  ).isRequired,
  value: PropTypes.object,
  onChange: PropTypes.func.isRequired
}

// @ts-ignore
FlagList.defaultProps = {
  value: {}
}

export default FlagList
